exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1IzHk1pv3-nrmZFv5i_hR-{height:0;width:0}", ""]);
// Exports
exports.locals = {
	"printIframe": "_1IzHk1pv3-nrmZFv5i_hR-"
};